<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #title-buttons>


        <!--ESPECIFICO POLIMIX-->
        <PrintLabelDialog
            @onSubmit="onSubmitPrint" :label-id="2"
            :disable-print="printItemsOptions.length===0"
            :list="printItemsOptions"
            :foreignKey="form.expeditionId" foreign-key-column="expeditionId">


          <table class="table table-hover" v-if="printItemsOptions.length > 0">
            <thead>
            <th>

              Selecione os bags para impressão
              <div>
                <small>Marcar:
                  <a @click="selectAllItemsToPrint(true)" class="link-black">Todos</a> /
                  <a @click="selectAllItemsToPrint(false)" class="link-black">Nenhum</a>
                </small>
              </div>

            </th>
            </thead>
            <tbody>
            <tr v-for="(item,index) in printItemsOptions" :key="index">
              <td class="d-flex">
                <t-input checked :label="item.originCodeLabel" v-model="item.value"/>
              </td>
            </tr>
            </tbody>
          </table>

          <t-msg danger v-else>Nenhum bag inserido pela guia Produtos, insira antes de realizar a impressão</t-msg>

        </PrintLabelDialog>

        <t-button @click="openDialogPrintLabel()" v-if="command !== 'insert'">
          <b-icon-printer></b-icon-printer>
          Imprimir Etiqueta
        </t-button>

        <t-button v-if="command !== 'insert'"
                  @click="downloadReport(7, form.expeditionId, 'LAUDO_QUALIDADE_' + form.expeditionNumber)">
          <b-icon-file-earmark-check></b-icon-file-earmark-check>
          Gerar Laudo de Qualidade
        </t-button>

      </template>

      <t-input v-model="form[fieldKey]" hidden/>

      <t-form-tab title="Dados Básicos">

        <b-row>

          <t-input v-model="form.expeditionNumber" lpad="3" cols="3" label="Cód. Expedição" fixed/>

          <t-input v-model="form.originInvoiceCode" :add-error="error.originInvoiceCode" cols="3" label="Nota Fiscal"/>


          <b-col cols="6">
            <t-input-person customer required :add-error="error.customerId"
                            v-model="form.customerId"/>

          </b-col>


        </b-row>
        <b-row>

          <t-input v-model="form.expeditionStatusId" required cols="4" :options="typeExpeditionStatusOptions" select
                   first-default
                   label="Status Expedição"/>

          <t-input v-model="form.companyId"
                   :options="companyOptions"
                   cols="4" required
                   label="Empresa" select/>

          <t-input v-model="form.issueDate" required cols="4" date date-now label="Data de Emissão"/>

        </b-row>


        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status" class="mb-2"/>

      </t-form-tab>

      <template #out-of-form>

        <t-form-tab title="Produtos" hash="product"
                    :disabled="!relationAccessPageGeneral('stock-expedition-order-product')" lazy>
          <ExpeditionOrderItem :foreign-key="form.expeditionId"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ExpeditionOrderItem from "@/views/modules/stock/ExpeditionOrderProduct";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";
import PrintLabelDialog from "@/views/modules/general/PrintLabelDialog";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ExpeditionOrderForm',
  components: {PrintLabelDialog, ExpeditionOrderItem},
  data() {
    return {
      path: "stock/expedition-order", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "expeditionId",
      form: {
        expeditionId: 0,
        expeditionNumber: 0,
        companyId: 0,
        customerId: 0,
        expeditionStatusId: 0,
        issueDate: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        originInvoiceCode: "",
        customerId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeExpeditionStatusOptions: [],
      companyOptions: [],
      printItemsOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.typeExpeditionStatusOptions = response.typeExpeditionStatusOptions
        this.companyOptions = response.companyOptions
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      await http.count("stock/expedition-order-product", this.form.expeditionId).then(async (count) => {

        if (count > 0) {
          await this.setSendingDefault()
        } else {
          ui.msgError(this, "Insira pelo menos 1 produto para gravar a Expedição");
        }

      }).catch(error => this.responseError(error))

      //

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async openDialogPrintLabel() {

      //Atualiza listagem de produtos inseridos
      await http.list("stock/expedition-order-product?expeditionId=" + this.form.expeditionId).then((list) => {

        this.printItemsOptions = []

        for (const item of list) {

          //originCodeLabel
          const newItem = {
            expeditionProductId: item.expeditionProductId,
            originCodeLabel: item.originCodeLabel,
            value: true,
          }

          this.printItemsOptions.push(newItem)

        }


        //Abre dialogo de impressão de etiqueta
        this.openDialogForm('modal-print-label')


      }).catch(error => this.responseError(error))


    },

    async onSubmitPrint() {

      ui.msg(this, "Impressão Etiqueta Expedição", "Impressão enviada com sucesso!");

    },

    selectAllItemsToPrint(checked) {

      for (let item of this.printItemsOptions) {
        item.value = checked
      }

    }

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>